import * as React from 'react';
import { SVGProps } from 'react';

const IconStopSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 5h14v14H5z" />
  </svg>
);
export default IconStopSizeM;
